import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const requestPasswordReset = data => {
  return request(`${apiUrl}/user/forgot-password`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
};
